export const GOOGLE_ONE_TAP_REDIRECTING_EVENT = "google-one-tap:redirecting";
